class Layout {
    constructor() {}

    addLabel(id) { throw new Error('not implemented'); }
    removeLabel(id) { throw new Error('not implemented'); }
    setLabel(id, data) { throw new Error('not implemented'); }

    setMask(mask) { throw new Error('not implemented'); }

    update(useMask) { throw new Error('not implemented'); }

    getLabel(id) { throw new Error('not implemented'); }
}

export default Layout;
